var $ = require('jquery')

$(document).on('click', 'a[href="#"]', function(e) {
  e.preventDefault()
})
